import type { IconProps } from "types";

const DAS2Icon = ({width = "21", height="20", color = "#141516"}: IconProps) => {
    return (
        <svg width={width} height={height} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.3333 5H19.8333V6.66667H19V15.8333H19.8333V17.5H1.5V15.8333H2.33333V6.66667H1.5V5H4V3.33333C4 3.11232 4.0878 2.90036 4.24408 2.74408C4.40036 2.5878 4.61232 2.5 4.83333 2.5H16.5C16.721 2.5 16.933 2.5878 17.0893 2.74408C17.2455 2.90036 17.3333 3.11232 17.3333 3.33333V5ZM17.3333 6.66667H4V15.8333H6.5V10H8.16667V15.8333H9.83333V10H11.5V15.8333H13.1667V10H14.8333V15.8333H17.3333V6.66667ZM5.66667 4.16667V5H15.6667V4.16667H5.66667Z"
                fill={color}
            />
        </svg>
    );
}

export default DAS2Icon;